import React from 'react';
import classnames from 'classnames';
import _ from 'lodash';

import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux'
import store from '../../Redux';
import { doPost, doLoad, doPut, select, doDelete, apiUrlOpen, doDuplicate } from '../../Redux/Actions'
import Filter from '../../Components/Filter';

import AddIcon from '@material-ui/icons/Add';
import PrintIcon from '@material-ui/icons/Print';
import FolderIcon from '@material-ui/icons/Folder';

import { TextFieldHelper, SelectFieldWrapper } from '../../Components/Fields';
import Table from '../../Components/Table';
import Loader from '../../Components/Loader';
import Master from '../../Components/Master';

import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Dialog from '../../Components/Dialog';
import Grid from '@material-ui/core/Grid';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';

//import qs from 'query-string'
import moment from 'moment'
import 'moment/locale/de'
moment.locale("de");

const styles = theme => ({
    fab: {
       position: 'absolute',
       bottom: theme.spacing.unit * 2,
       right: theme.spacing.unit * 2,
    },
    iconButton: {
        marginRight: "24px",
        top: "50%",
        display: "inline-block",
        position: "relative",
        transform: "translateY(-50%)",
    },
})

const columns = [
    "Farbe",
    "Paket",
    "Nummer",
    "Name",
    "Von",
    "Bis",
    "Geändert",
];

const options = {}

var FahrplanDialogForm = ({handleChange, data}) => {
    return (
        <div>
            <Grid container spacing={8}>
                <TextFieldHelper n={4} value={data.nummer} onChange={handleChange('nummer')} label="Nummer" />
                <TextFieldHelper n={8} value={data.name} onChange={handleChange('name')} label="Name" />
            </Grid>
        </div>
    )
}

class Fahrplan extends Master {

    state = {
        fahrplan: {},
        putLoading: {},
        tabs: 0,
        dialogOpen: false,
        newEntry: {

        },
        tableFilter: {

        },
        queryData: {

        },
        selectedRows: []
    }

    getQueryStrings = () => { 
      var assoc  = {};
      var decode = function (s) { return decodeURIComponent(s.replace(/\+/g, " ")); };
      var queryString = window.location.search.substring(1); 
      var keyValues = queryString.split('&'); 

      for(var i in keyValues) { 
        var key = keyValues[i].split('=');
        if (key.length > 1) {
          assoc[decode(key[0])] = decode(key[1]);
        }
      } 

      return assoc; 
    } 

    prepareAndLoadData = () => {
        //var queryData = qs.parse(this.props.history.location.search)
        var queryData = this.getQueryStrings()
        if(queryData.sonderfahrten === undefined) {
            queryData.sonderfahrten = false
        }
        if(queryData.sonderfahrten === this.state.tableFilter.sonderfahrten) {
            return
        }
        this.state.tableFilter = {
            ...queryData,
            ...this.state.filter
        }
        this.props.doLoad(this.state.tableFilter)
    }

    componentWillReceiveProps() {
        this.prepareAndLoadData()
    }

    componentDidMount() {
        document.title = "Fahrplan"
        this.prepareAndLoadData()
    /*}

    componentWillMount() {*/
        this.props.doFilter()
        this.unsubscribe = store.subscribe(() => {
                var genericData = select(store.getState(), "fahrplan")
                if(_.has(genericData, "putLoading") && this.state.putLoading !== genericData.putLoading) {
                    this.setState({
                        putLoading: genericData.putLoading
                    })
                }
                if(_.has(genericData, "dialogOpen") && this.state.dialogOpen !== genericData.dialogOpen) {
                    this.setState({
                        dialogOpen: genericData.dialogOpen
                    })
                }
            }
        )
    }

    componentWillUnmount() {
        this.unsubscribe()
    }

    handleClickOpen = () => {
        this.setState({
            dialogOpen: this.state.dialogOpen ? false : true
        });
    }

    postData = () => {
        if(this.state.tableFilter.sonderfahrten) {
            this.state.newEntry.sonderfahrt = true
        }
        this.props.doPost(this.state.newEntry)
        this.setState({
            newEntry: {}
        })
    }

    handleChange = name => event => {
        this.state.newEntry[name] = event.target.value
        this.setState({
            newEntry: this.state.newEntry
        });
    }

    /*populate = (data) => {
        this.state.tableFilter = {
            ...this.state.tableFilter,
            ...data
        }
        this.props.doLoad(data)
    }*/

    deleteAction = (id) => {
        if (window.confirm('Willst du den Eintrag wirklich löschen?')) {
            this.props.doDelete(id)
        }
    }

    duplicateAction = (id) => {
        //if (window.confirm('Willst du den Eintrag wirklich löschen?')) {
            this.props.doDuplicate(id)
        //}
    }

    gotoToDetail = (rowIndex, data) => {
        this.props.history.push("fahrplan/"+this.props.fahrplan.data[rowIndex].id)
    }

    customToolbarSelect = () => {
        return (
            <Tooltip title={"Fahrpläne ausdrucken"}>
                <IconButton className={this.props.classes.iconButton} onClick={this.printFahrlaene}>
                    <PrintIcon className={this.props.classes.deleteIcon} />
                </IconButton>
            </Tooltip>
        )
    }

    printFahrlaene = () => {
        this.props.print(this.state.selectedRows)
    }

    onRowsSelect = (currentRowsSelected, rowsSelected) => {
        var fahrplaene = []
        rowsSelected.forEach((item) => {
            fahrplaene.push(this.props.fahrplan.data[item.index].id)
        })
        this.state.selectedRows = fahrplaene
    }

    addFilter = (filter) => {
        this.props.doLoad({
            jahr: filter ? filter : ""
        })
    }

    render() {

        var {
            classes, ordner, filter
        } = this.props

        var {
            dialogOpen, tableFilter, isLoading
        } = this.state

        if(isLoading) {
            return (
                <Loader />
            )
        }

        var items = []
        if(_.has(this.props, 'fahrplan.data') && this.props.fahrplan.data.length > 0) {
            this.props.fahrplan.data.forEach((item) => {
                items.push([
                    item.farbe === undefined ? "" : <div style={{background: item.farbe}} className={classnames("color-block")}></div>,
                    item.paket === undefined ? "-" : item.paket,
                    item.nummer === undefined ? "-" : item.nummer,
                    item.name === undefined ? "-" : item.name,

                    item.von === undefined ? "-" : moment(item.von).format('L'),
                    item.bis === undefined ? "-" : moment(item.bis).format('L'),
                    item.UpdatedAt === undefined ? "-" : moment(item.UpdatedAt).format("DD.MM.YY hh:mm"),

                    item.id
                ])
            })
        }

        var title = "Fahrpläne"
        if(tableFilter.sonderfahrten) {
            title = "Sonderfahrten"
        }

        return (
            <Grid container spacing={8}>
                <Grid item xs={12}>

                    <Filter data={filter.data} filter={this.filter} active={this.state.filter} />

                    <Table
                        title={title}
                        key={"items"+items.length}
                        data={items}
                        currentPage={this.props.fahrplan.page}
                        count={this.props.fahrplan.count}
                        columns={columns}
                        populate={this.populate}
                        onDelete={this.deleteAction}
                        onDuplicate={this.duplicateAction}
                        rowClick={this.gotoToDetail}
                        classes={"fahrplaene"}
                        options={{
                            selectableRows: false,
                        }}
                    />

                    <Button variant="fab" className={classes.fab} onClick={this.handleClickOpen} color={"primary"}>
                        <AddIcon />
                    </Button>
                    <Dialog
                        title="Neuer Fahrplan"
                        saveAction={this.postData}
                        closeAction={this.handleClickOpen}
                        open={dialogOpen}
                    >
                        <FahrplanDialogForm data={this.state.newEntry} handleChange={this.handleChange} />
                    </Dialog>

                </Grid>

            </Grid>
        )
    }

}

const mapStateToProps = state => ({
    fahrplan: state.fahrplan,
    filter: state.filter,
})

const mapDispatchToProps = (dispatch, ownProps) => ({

    doFilter: () => dispatch(doLoad("filter", "api/generic/fahrplan/filter")),

    doLoad: (filter) => dispatch(doLoad("fahrplan", "api/generic/fahrplan/list", filter)),
    doPost: (data) => dispatch(doPost("fahrplan", "api/generic/fahrplan", data)),
    doDuplicate: (id) => dispatch(doDuplicate("fahrplan", "api/generic/fahrplan/duplicate/"+id)),
    doDelete: (id) => dispatch(doDelete("fahrplan", "api/generic/fahrplan/"+id, id)),
    doSearch: (filter) => dispatch(doLoad("fahrplan", "api/generic/fahrplan/list", filter)),

    print: (ids) => dispatch(apiUrlOpen("api/pdf/fahrplan/multi", "&ids=" + ids.join(","))),

})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(Fahrplan));



// WEBPACK FOOTER //
// ./src/Routes/Fahrplan/index.js